import React from 'react';

const ProductMarketingTab = ({ selected, data }) => {
  if (!data) {
    return null;
  }

  return (
    <div className={`tabbed-content-container${selected ? ' selected' : ''}`} dangerouslySetInnerHTML={{ __html: data.data?.description }} />
  );
};

export default ProductMarketingTab;
